import './CurrentProject.css'

const background = require('./images/background.png')

function CurrentProject() {
    return (
        <section className='current-project' style={{
            backgroundImage: `url(${background})`,
            backgroundRepeat: 'no-repeat',
            backgroundSize: '100%'
        }}>
            <h1>Current project</h1>
            <p>Real-time update from
                <a href='https://github.com/qr3n'> GitHub</a>
            </p>

            <div className='current-project__project'>
                <h1>Melon</h1>
                <p>A custom react library for animations...</p>
                <button className='current-project__project__button'>View all</button>
            </div>
        </section>
    )
}

export default CurrentProject